import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/icons.css'
import './assets/reset.css'
import { Button, Input, Select, Option, Dialog, Form, FormItem, Upload, Pagination, Message, MessageBox, Table, TableColumn } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/element-fix.css'
import dataV from '@jiaminghi/data-view'

// 按需引入ElementUI组件
Vue.use(Button)
Vue.use(Input)
Vue.use(Select)
Vue.use(Option)
Vue.use(Dialog)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Upload)
Vue.use(Pagination)
Vue.use(Table)        
Vue.use(TableColumn)   

// 全局方法
Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm

// 创建事件总线
Vue.prototype.$bus = new Vue()

Vue.config.productionTip = false

// 注册DataV组件库
Vue.use(dataV)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
